// Modules
import React from 'react';
import { CellProps } from 'react-table';

// Types
import { IBasstrakkAngler } from '../../types';

// Config
import AnglerCell from '../../components/Column/AnglerCell';
import { CLASS_PREFIX } from '../../config';
/**
 * Basstrakk Standings columns
 */
export const AOYColumns = [
  {
    Header: 'Rank',
    accessor: 'rank',
    id: 'rank',
    className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--700 ${CLASS_PREFIX}cell__rank`,
    headerClassName: `${CLASS_PREFIX}header__rank`,
    width: 35,
    align: 'center',
  },
  {
    Header: 'Angler', // ▶
    id: 'angler', // Must have an id
    accessor: 'name',
    className: `${CLASS_PREFIX}cell ${CLASS_PREFIX}cell--700 ${CLASS_PREFIX}cell__angler`,
    headerClassName: `${CLASS_PREFIX}header__angler`,
    minWidth: 115,
    Cell: ({ row, index, width }: CellProps<IBasstrakkAngler>) => (
      <AnglerCell
        anglerName={row.values.angler}
        index={index}
        isExpanded={row.isExpanded}
        width={width}
        tid={row.original.TournamentId}
      />
    ),
  },
  // Total
  {
    Header: 'Total',
    className: `${CLASS_PREFIX}cell`,
    headerClassName: `${CLASS_PREFIX}header`,
    accessor: 'score',
    width: 45,
  },
];
